

export const index = 3;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/workshops/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/3.CbNat-Bz.js","_app/immutable/chunks/KZK0-soZ.js","_app/immutable/chunks/BZTNq1Um.js","_app/immutable/chunks/2mOfPPFS.js","_app/immutable/chunks/CW0xTaoG.js","_app/immutable/chunks/BGfRHZdV.js","_app/immutable/chunks/DW-TuIxf.js"];
export const stylesheets = [];
export const fonts = [];
